import { NewGoal, NewGoalWithID, NewTagWithID } from '@griply/types';
import { defaultTagColorOption } from '@griply/utils';
import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const useNewEntities = () => {
  const [goalsToCreate, setGoalsToCreate] = useState<NewGoalWithID[]>([]);
  const [tagsToCreate, setTagsToCreate] = useState<NewTagWithID[]>([]);

  const addGoalToCreate = useCallback(
    (goal: NewGoal) =>
      setGoalsToCreate((prev) => [...prev, { id: uuidv4(), ...goal }]),
    [],
  );

  const addTagToCreate = useCallback((name: string) => {
    const tag = { id: uuidv4(), name, color: defaultTagColorOption.value };
    setTagsToCreate((prev) => [...prev, tag]);
    return tag;
  }, []);

  const resetEntities = useCallback(() => {
    setGoalsToCreate([]);
    setTagsToCreate([]);
  }, []);

  return {
    addGoalToCreate,
    addTagToCreate,
    goalsToCreate,
    tagsToCreate,
    resetEntities,
  };
};
